/**
 * Helpers для работы с /web/deliveries/events
 * CARGODEV-83986
 */

export type DeliveriesRevisionEntry = {
  delivery_id: string
  revision: number
  order_id?: string
  order_provider_id?: string
  commit_revision?: number
  queue?: string
}

/**
 * Parse revision string (JSON array) into typed entries
 */
export function parseDeliveriesRevision(revision?: string): DeliveriesRevisionEntry[] {
  if (!revision || typeof revision !== 'string') {
    return []
  }

  try {
    const parsed = JSON.parse(revision)
    if (!Array.isArray(parsed)) {
      console.warn('[parseDeliveriesRevision] revision is not an array:', typeof parsed)
      return []
    }
    return parsed as DeliveriesRevisionEntry[]
  } catch (error) {
    console.warn('[parseDeliveriesRevision] failed to parse revision:', error)
    return []
  }
}

/**
 * Serialize revision entries back to JSON string for request body
 */
export function serializeDeliveriesRevision(entries: DeliveriesRevisionEntry[]): string {
  return JSON.stringify(entries)
}

/**
 * Check if two delivery_id strings match (exact or prefix match with '/')
 * Examples:
 *   isSameDeliveryId('uuid', 'uuid') → true
 *   isSameDeliveryId('uuid/1782392416', 'uuid') → true
 *   isSameDeliveryId('uuid', 'uuid/1782392416') → true
 */
export function isSameDeliveryId(a: string, b: string): boolean {
  return a === b || a.startsWith(`${b}/`) || b.startsWith(`${a}/`)
}
